// for shopify
var current_open_player_id = "";
$(document).ready(function () {
  $('.product-video-item-play-shopify').on('click', function () {
    console.log("play video");
    var modal_to_open = $(this).attr('data-modal-id');
    var video_id = $(this).attr('video-id');
    current_open_player_id = video_id;
    $(".overlay, .modalWindow[modal-id='" + modal_to_open + "']").fadeIn();

    var defaultVolume = 0.4;
    const player = videojs(current_open_player_id, {}, function () {
      this.volume(defaultVolume);
    });

    player.play();
  });
});

settings = {
  objModalCloseBtn: '.overlay, .modal-close-btn',
};
//On clicking the modal background
$(settings.objModalCloseBtn).bind('click', function () {
  $('.modal').fadeOut();
  const player = videojs(current_open_player_id);

  player.pause();
});
// end for shopify

// for Youtube
$(document).ready(function () {
  $(".product-video-item-play-yt").on("click", function () {
    console.log("add html to modal");
    console.log("play video yt");
    var modal_to_open = $(this).attr('data-modal-id');
    var video_id = $(this).attr('video-id');
    var i_data = $(this).attr('i-data');
    current_open_player_id = video_id;
    $(".overlay, .modalWindow-yt.modalWindow[modal-id='" + modal_to_open + "']").fadeIn();

    var video_url = $(this).attr('video-url');
    
    var $video = $('<video>', {
      id: 'youtube-player-' + i_data,
      class: 'video-js vjs-16-9',
      controls: true,
      autoplay: true,
      // width: 640,
      // height: 360,
      'data-setup': JSON.stringify({
        techOrder: ['youtube'],
        sources: [{
          type: 'video/youtube',
          src: video_url
        }],
        // youtube: {
        //   ytControls: 2
        // }
      })
    });

    console.log("play or not");
    var defaultVolume = 0.4;

    var $checkIfIsLoaded = $('.modalWindow.modalWindow-yt[modal-id="'+modal_to_open+'"] div[data-setup]')
    if($checkIfIsLoaded && $checkIfIsLoaded.length > 0){
      // already loaded no need to reload
      var player = videojs(current_open_player_id, {},
      function(){
        this.volume(defaultVolume);
      }
      );
      player.play();
    }
    else{
      $('.modalWindow.modalWindow-yt[modal-id="'+modal_to_open+'"] .modalWrapper .product-video-item.youtube').empty().append($video);
      // Initialize Video.js manually
      var player = videojs(current_open_player_id, {
        techOrder: ['youtube'],
        sources: [{
          type: 'video/youtube',
          src: video_url
        }],
        // youtube: {
        //   ytControls: 2
        // }
      },
      function(){
        this.volume(defaultVolume);
      }
      );
    }
  });
});
// end for youtube